module.exports = __webpack_public_path__ + "img/team_2.fcd620bd.jpg";